import styled from "styled-components";

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 6rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  border-top: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.gray[400]};
  position: sticky;
  bottom: 0;
  z-index: 500;
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% / 3);
  height: 100%;

  &:nth-child(2) {
    width: auto;
  }

  &:nth-child(3) {
    justify-content: flex-end;
  }

  &:nth-child(1),
  &:nth-child(3) {
    flex-grow: 1;
  }
`;

const Control = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  padding: 0 2.4rem;
  color: ${({ theme }) => theme.live.colors.primary};
  cursor: pointer;
  text-decoration: none;

  ${({ theme }) => theme.media.sm`
    width: 100%;
    font-size: 1.5rem;
    line-height: 2.4rem;
  `}

  svg {
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    fill: ${({ theme }) => theme.live.colors.primary};
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Prev = styled(Control)`
  justify-content: flex-start;
  min-width: 0;

  ${({ theme }) => theme.media.sm`
    padding: 0 1.4rem 0 1rem;
  `}

  svg {
    margin-right: 1.2rem;

    ${({ theme }) => theme.media.sm`
      margin-right: 0.4rem;
    `}
  }
`;

export const Next = styled(Control)`
  justify-content: flex-end;
  min-width: 0;

  ${({ theme }) => theme.media.sm`
    padding: 0 1rem 0 1.4rem;
  `}

  svg {
    margin-left: 1.2rem;

    ${({ theme }) => theme.media.sm`
      margin-left: 0.4rem;
    `}
  }
`;

export const EditContainer = styled(Control)`
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    padding: 0;
  `}
`;

export const Edit = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.live.colors.primary};

  svg {
    width: 1.8rem;
    height: 1.8rem;
    margin: 0;
    fill: ${({ theme }) => theme.styleGuide.colors.white};
  }
`;

export const Border = styled.div`
  width: 100%;
  height: 0.5rem;
  background-color: ${({ theme }) => theme.live.colors.secondary};
`;
